/**
 * Bio modal for the Backed by science section.
 */

import tingle from "tingle.js";
import "tingle.js/dist/tingle.min.css";

const BIO_TRIGGER_SELECTOR = "[js-scientist-view-bio]";

const CLOSE_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M19.2806 18.2198C19.3503 18.2895 19.4056 18.3722 19.4433 18.4632C19.481 18.5543 19.5004 18.6519 19.5004 18.7504C19.5004 18.849 19.481 18.9465 19.4433 19.0376C19.4056 19.1286 19.3503 19.2114 19.2806 19.281C19.2109 19.3507 19.1282 19.406 19.0372 19.4437C18.9461 19.4814 18.8485 19.5008 18.75 19.5008C18.6514 19.5008 18.5539 19.4814 18.4628 19.4437C18.3718 19.406 18.289 19.3507 18.2194 19.281L12 13.0607L5.78061 19.281C5.63988 19.4218 5.44901 19.5008 5.24999 19.5008C5.05097 19.5008 4.8601 19.4218 4.71936 19.281C4.57863 19.1403 4.49957 18.9494 4.49957 18.7504C4.49957 18.5514 4.57863 18.3605 4.71936 18.2198L10.9397 12.0004L4.71936 5.78104C4.57863 5.64031 4.49957 5.44944 4.49957 5.25042C4.49957 5.05139 4.57863 4.86052 4.71936 4.71979C4.8601 4.57906 5.05097 4.5 5.24999 4.5C5.44901 4.5 5.63988 4.57906 5.78061 4.71979L12 10.9401L18.2194 4.71979C18.3601 4.57906 18.551 4.5 18.75 4.5C18.949 4.5 19.1399 4.57906 19.2806 4.71979C19.4213 4.86052 19.5004 5.05139 19.5004 5.25042C19.5004 5.44944 19.4213 5.64031 19.2806 5.78104L13.0603 12.0004L19.2806 18.2198Z" fill="#034638"/>
</svg>`;

let activeBioModal = null;

const customizeCloseButton = (modal) => {
  try {
    const modalBox =
      modal.modalBox || modal.modal?.querySelector(".tingle-modal-box");
    const closeButton =
      modal.modalCloseBtn || modal.modal?.querySelector(".tingle-modal__close");
    const closeIcon =
      modal.modalCloseBtnIcon ||
      closeButton?.querySelector(".tingle-modal__closeIcon");

    if (closeIcon) {
      closeIcon.innerHTML = CLOSE_ICON_SVG;
    }

    if (modalBox && closeButton && closeButton.parentElement !== modalBox) {
      modalBox.appendChild(closeButton);
    }
  } catch (error) {
    console.error("[backed-by-science] Failed to customize close button", error);
  }
};

const destroyActiveBioModal = () => {
  if (!activeBioModal) return;

  try {
    activeBioModal.destroy();
  } catch (error) {
    console.error("[backed-by-science] Failed to destroy modal", error);
  }

  activeBioModal = null;
};

const openScientistBioModal = (element) => {
  destroyActiveBioModal();

  const name = element.dataset.name || "";
  const university = element.dataset.university || "";
  const bio = element.dataset.bio || "";

  const modal = new tingle.modal({
    footer: false,
    stickyFooter: false,
    closeMethods: ["overlay", "button", "escape"],
    cssClass: ["scientists-bio-modal"],
    onClose() {
      // Keep tingle's shared busy flag from blocking future opens.
      if (activeBioModal === modal) {
        activeBioModal = null;
      }
    },
  });

  activeBioModal = modal;

  modal.setContent(`
      <div class="scientists-bio-modal__header">
        <h2 class="scientists-bio-modal__name">${name}</h2>
        ${
          university
            ? `<h3 class="scientists-bio-modal__university">${university}</h3>`
            : ""
        }
      </div>
      <div class="scientists-bio-modal__bio">${bio}</div>
    `);

  // Customize after open so a failed icon swap cannot leave tingle's busy flag stuck.
  modal.open();
  customizeCloseButton(modal);

  const isKeyboardNavigation = element === document.activeElement;
  const firstFocusable = modal.modal.querySelector("button");

  if (isKeyboardNavigation && firstFocusable) {
    setTimeout(() => {
      firstFocusable.focus();
    }, 500);

    firstFocusable.addEventListener("click", function () {
      element?.focus();
    });
  }
};

export const buildBackedByScience = () => {
  if (window.__backedByScienceBioModalInitialized) return;
  window.__backedByScienceBioModalInitialized = true;

  document.addEventListener("click", (event) => {
    const target =
      event.target instanceof Element
        ? event.target
        : event.target?.parentElement;
    const element = target?.closest?.(BIO_TRIGGER_SELECTOR);
    if (!element) return;

    event.preventDefault();
    event.stopPropagation();
    openScientistBioModal(element);
  });
};
